import {
  HttpClient, HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { apiConfiguration } from '../../../../configurations/api-configuration';
import { AccessService } from '../../../application/services/AccessService';
import { HttpResponse } from '../../../application/types/HttpResponse';
import {
  SaveSeasonData,
  SaveSeasonPhaseData,
  Season,
  SeasonPhase,
} from '../../types/Event';

@Injectable()
export class SeasonApiService {
  private readonly seasonsUrl = `${apiConfiguration.baseApiUrl}/seasons`;

  public constructor(
    private http: HttpClient,
    private accessService: AccessService,
  ) { }

  public async getSeasons(): Promise<HttpResponse<Season[]>> {
    return lastValueFrom(this.http.get<HttpResponse<Season[]>>(this.seasonsUrl, { headers: this.getHeaders() }));
  }

  public async createSeason(data: SaveSeasonData): Promise<HttpResponse<Season>> {
    return lastValueFrom(this.http.post<HttpResponse<Season>>(this.seasonsUrl, data, { headers: this.getHeaders() }));
  }

  public async updateSeason(seasonId: string, data: Partial<SaveSeasonData>): Promise<HttpResponse<Season>> {
    return lastValueFrom(this.http.put<HttpResponse<Season>>(`${this.seasonsUrl}/${seasonId}`, data, { headers: this.getHeaders() }));
  }

  public async deleteSeason(seasonId: string): Promise<HttpResponse<void>> {
    return lastValueFrom(this.http.delete<HttpResponse<void>>(`${this.seasonsUrl}/${seasonId}`, { headers: this.getHeaders() }));
  }

  public async createSeasonPhase(seasonId: string, data: SaveSeasonPhaseData): Promise<HttpResponse<SeasonPhase>> {
    return lastValueFrom(this.http.post<HttpResponse<SeasonPhase>>(`${this.seasonsUrl}/${seasonId}/phases`, data, { headers: this.getHeaders() }));
  }

  public async updateSeasonPhase(seasonId: string, phaseId: string, data: Partial<SaveSeasonPhaseData>): Promise<HttpResponse<SeasonPhase>> {
    return lastValueFrom(this.http.put<HttpResponse<SeasonPhase>>(`${this.seasonsUrl}/${seasonId}/phases/${phaseId}`, data, { headers: this.getHeaders() }));
  }

  public async deleteSeasonPhase(seasonId: string, phaseId: string): Promise<HttpResponse<void>> {
    return lastValueFrom(this.http.delete<HttpResponse<void>>(`${this.seasonsUrl}/${seasonId}/phases/${phaseId}`, { headers: this.getHeaders() }));
  }

  private getHeaders(): HttpHeaders {
    const token = this.accessService.getToken();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }
}
